import { gql } from '@apollo/client';

export const NEGATIVE_KEYWORDS_QUERY = gql`
  query {
    negativeKeywords
  }
`;
